import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { retryUnlessClientError } from '~/shared/lib/api-error'
import { DOCUMENT_AGENT_QUERY_KEYS } from '../config'
import type { DocumentAgentRunsResponse } from '../model'

export function useDocumentAgentRuns(
  documentKey: string,
  { enabled = true, staleTime }: { enabled?: boolean; staleTime?: number } = {},
) {
  return useQuery({
    queryKey: DOCUMENT_AGENT_QUERY_KEYS.documentRuns(documentKey),
    queryFn: async () => {
      const response = await apiClient.client.get({
        url: '/document-agent/documents/{key}/runs',
        path: { key: documentKey },
        throwOnError: true,
      })
      return response.data as DocumentAgentRunsResponse
    },
    enabled,
    staleTime,
    retry: retryUnlessClientError,
  })
}
